import React from 'react';
import H2 from '../../Components/H2';
import styled, { keyframes } from 'styled-components';
import { FormattedMessage, injectIntl } from 'react-intl';
import { Helmet } from "react-helmet";
import Success from '../../Components/Success';
import SocialButtons from '../../Components/SocialButtons';
import { zoomIn } from 'react-animations';
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { BottomWrapper, CoreWrapper, TextCenter, TopWrapper } from "../../Components/Layout";
import PoweredBy from "../../Components/PoweredBy";
import { ToolbarWithLogo } from "../../Components/Toolbar";
import { humanizeDayOfWeek, serverDayDate, serverShortTime } from "../../Common/Helpers";
import H1 from "../../Components/H1";
import H3 from "../../Components/H3";
import ContainerPage from "../ContainerPage";
import { Analytics } from "../../Common/Analytics";
import { Button } from "rmwc/Button/index";
import Sizes from "../../Assets/Sizes";
import Link from "../../Components/Link";
import {getSafely} from "@tomeravni/easybizy-js-common/common";

const bounceAnimation = keyframes`${ zoomIn }`;

const BouncyDiv = styled.div`
  position: absolute;
  bottom: 2rem;
  animation: ${ bounceAnimation } .6s ease-in 0s backwards;
`;

const MyH2 = styled(H2)`
  text-align: center;
  font-weight: ${ p => !!p.bold ? 'bold' : 'normal' };
`;

const MeetingSetMessage = styled(TextCenter)`
`;


const ForwardButton = styled(Button)`
  background-color: ${ p => p.theme.properties.outlinedPrimary ? 'transparent' : p.theme.colors.primaryText } !important;
  color: ${ props => props.theme.colors.surfaceBottomInverted };
  border-radius: ${ Sizes.defaultBorderRadius };
  border: 1px solid ${ props => props.theme.colors.primaryTextInverted };
  font-family: inherit;
  font-size: 20px;
  padding: 20px;
  min-height: 50px;
  margin-bottom: 100px;

  a {
    color: ${ props => props.theme.colors.primaryTextInverted } !important;
  }
`;

const AddToCalendarButton = styled(Button)`
  background-color: transparent !important;
  color: ${ props => props.theme.colors.surfaceBottomInverted };
  border-radius: ${ Sizes.defaultBorderRadius };
  border: 1px solid ${ props => props.theme.colors.primaryTextInverted };
  font-family: inherit;
  font-size: 20px;
  padding: 20px 0;
  min-height: 50px;
  margin-bottom: 100px;

  a {
    color: ${ props => props.theme.colors.primaryTextInverted } !important;
    padding: 20px;
    display: inline-block;
  }
`;


class SuccessPage extends ContainerPage {
	state = {
		socialVisible: false
	};

	componentDidMount() {
		this.loadingTimer = setTimeout(() => {
			this.safeSetState({ socialVisible: true });
			window.addToHomescreen();
			this.reloadConfigWithServices();
		}, 1000);


		this.setState({
			config: this.props.config
		});

		if (!this.props.scheduledMeetings) {
			return this.startOver();
		}

		Analytics.trackPage(this.props.location.pathname);
		this.props.scheduledMeetings.forEach(meeting => {
			Analytics.trackFacebookEvent('meeting-scheduled', {
				date: meeting.StartTime
			});
		});
	}


	componentDidUpdate(prevProps, prevState, snapshot) {
		const { ForwardUrlAfterSchedule } = this.state.config || {};
		if (this.redirectTimeout) {
			clearTimeout(this.redirectTimeout);
		}

		if (ForwardUrlAfterSchedule) {
			this.redirectTimeout = setTimeout(() => {
				window.location.href = ForwardUrlAfterSchedule;
			}, 5000);
		}
	}

	componentWillUnmount() {
		super.componentWillUnmount();
		if (this.redirectTimeout) {
			clearTimeout(this.redirectTimeout);
		}

		if (this.loadingTimer) {
			clearTimeout(this.loadingTimer);
		}
	}

	renderMeetingsResult() {
		const awaitingApproval = this.props.scheduledMeetings.some(x => x.WaitingForApproval);
		const singleMeeting = this.props.scheduledMeetings.length === 1;

		let scheduleMessage;
		if (!awaitingApproval) {
			scheduleMessage = <FormattedMessage id="schedule.meetingScheduled"/>
		} else {
			scheduleMessage = <FormattedMessage id="schedule.meetingRequested"/>
		}

		let meetingDetails = singleMeeting ? this.renderMeetingDefaultRow(this.props.scheduledMeetings[0]) :
			this.renderMultipleMeetingRows(this.props.scheduledMeetings)

		return <div>
			<H1 invertedColors={ true }>
				{ scheduleMessage }
			</H1>
			{ meetingDetails }
			<Success width={ 90 } height={ 130 }/>
			{ awaitingApproval && <MyH2 bold={ true } invertedColors={ true }><FormattedMessage
				id="schedule.meetingRequestedExplanation"/></MyH2> }
		</div>

	}

	renderMeetingDefaultRow(meeting) {
		return (<H2 invertedColors={ true }>
			{ this.getMeetingDetails(meeting) }
		</H2>);
	}

	getMeetingDetails(meeting) {
		return (
			<div>{ humanizeDayOfWeek(meeting.StartTime) }, { serverDayDate(meeting.StartTime) }, { serverShortTime(meeting.StartTime) } </div>);
	}

	renderMultipleMeetingRows(meetings) {
		return <div>
			<H2><FormattedMessage id="schedule.meetingsScheduled"/></H2>
			{ meetings.forEach(meeting =>
				<H2>{ this.getMeetingDetails(meeting) }</H2>
			) }
		</div>
	}

	render() {
		const translatedMessage = this.props.intl.formatMessage({ id: 'schedule.meetingScheduleTitle' });
		const { SocialLinks, LastPageMessage, ForwardUrlAfterSchedule } = this.state.config || {};
		const ltr = !this.props.intl.locale.includes('he');
		const { icsUrl } = this.props;
		const toolbarLogo = getSafely(['theme', 'properties', 'avatarImage'], window) || (this.props.config && this.props.config.Logo) || '';

		return (
			<div className="transition-item detail-page detail-page__success">
				<Helmet>
					<title>{ translatedMessage }</title>
				</Helmet>
				<CoreWrapper padding={ true } loading={ this.props.loading } invertedColors={ true } ltr={ ltr }>
					<ToolbarWithLogo imageUri={ toolbarLogo } invertedColors={ true } hideBack={ true } ltr={ ltr }
									 rootUri={ this.getRoutePrefix() }/>
					<TopWrapper>
						<MeetingSetMessage>
							{ this.props.scheduledMeetings && this.renderMeetingsResult() }
							{ LastPageMessage && <H3 invertedColors={ true }>&nbsp;
								{ LastPageMessage }
							</H3> }
						</MeetingSetMessage>
						{ ForwardUrlAfterSchedule && <ForwardButton>
							<Link href={ ForwardUrlAfterSchedule }><FormattedMessage
								id="schedule.goBackForward"/></Link>
						</ForwardButton> }

						{ icsUrl && <AddToCalendarButton>
							<Link href={ icsUrl }><FormattedMessage
								id="add_to_calendar"/></Link>
						</AddToCalendarButton> }


						{ this.state.socialVisible && SocialLinks && <BouncyDiv>
							<SocialButtons
								urls={ SocialLinks }
							/>
						</BouncyDiv> }
					</TopWrapper>
					<BottomWrapper empty={ true }>
						<PoweredBy/>
					</BottomWrapper>
				</CoreWrapper>
			</div>
		);
	}
}

// export default SuccessPage;
const mapStateToProps = state => {
	return {
		config: state.schedule.configWithServices,
		scheduledMeetings: state.schedule.scheduledMeetings,
		icsUrl: state.schedule.icsUrl,
	};
};

const mapDispatchToProps = dispatch => {
	return {}
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(injectIntl(SuccessPage)));
